(() => {
  const REVIEW_URL = 'https://www.5sterrenspecialist.nl/aggregateJsonReviewData.json?hash=7O_JRhjpD1Otv-6DzrqpuPGQ4omU0NMmRcVtDURdn64';

  const CACHE_KEY = 'ft_5sterren_review_data';
  const CACHE_TIME = 60 * 60 * 1000; // 1 uur

  function updateReviews(data) {
    if (!data) return;

    const rating = Number(data.ratingValue);
    const bestRating = Number(data.bestRating || 10);
    const reviewCount = Number(data.reviewcount || data.ratingCount);

    if (!Number.isFinite(rating) || !Number.isFinite(reviewCount)) return;

    // Zet bijvoorbeeld 9,6/10 automatisch om naar 4,8/5
    const fiveStarScore = ((rating / bestRating) * 5)
      .toFixed(1)
      .replace('.', ',');

    document.querySelectorAll('[data-ft-review-score]').forEach((el) => {
      el.textContent = `${fiveStarScore}/5`;
    });

    document.querySelectorAll('[data-ft-review-count]').forEach((el) => {
      el.textContent = reviewCount.toLocaleString('nl-NL');
    });

    // Optioneel: toegankelijkheidslabel voor de sterren
    document.querySelectorAll('.ft-rating-stars, .ft-stars').forEach((el) => {
      el.setAttribute(
        'aria-label',
        `${fiveStarScore} van 5 sterren op basis van ${reviewCount.toLocaleString('nl-NL')} beoordelingen`
      );
    });
  }

  function readCache() {
    try {
      const cached = JSON.parse(localStorage.getItem(CACHE_KEY));

      if (
        cached &&
        cached.timestamp &&
        cached.data &&
        Date.now() - cached.timestamp < CACHE_TIME
      ) {
        return cached.data;
      }
    } catch (error) {
      // Cache negeren als deze ongeldig is
    }

    return null;
  }

  function saveCache(data) {
    try {
      localStorage.setItem(
        CACHE_KEY,
        JSON.stringify({
          timestamp: Date.now(),
          data: data
        })
      );
    } catch (error) {
      // Website blijft gewoon werken als localStorage niet beschikbaar is
    }
  }

  async function loadReviews() {
    // Geen externe request op pagina's waar nergens een reviewscore wordt getoond.
    if (!document.querySelector('[data-ft-review-score], [data-ft-review-count]')) return;

    const cached = readCache();

    if (cached) {
      updateReviews(cached);
      return;
    }

    try {
      const response = await fetch(REVIEW_URL, {
        method: 'GET',
        headers: {
          Accept: 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error(`Review feed gaf status ${response.status}`);
      }

      const data = await response.json();

      updateReviews(data);
      saveCache(data);
    } catch (error) {
      // Niets aanpassen:
      // de hardcoded fallback 4,8/5 en 548 blijft zichtbaar.
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadReviews);
  } else {
    loadReviews();
  }
})();